<template>
    <div>
       

         <v-card :elevation="0" class="v-sheet theme--light br-0" :loading="cardPreguntasLoading">
       
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" md="12" sm="12" xs="12">
                        <v-row>
                            <v-col cols="12" sm="12" md="7" class="pb-0 mb-0">
                                Responder Boleta
                            </v-col>
                                                
                            <v-col cols="12" sm="12" md="12" class="mt-0 pt-0 pb-0 mb-0">
                                {{datosBoleta.codigo}} - {{datosBoleta.nombreIndice}}
                            <!--<small class="mt-0 pt-0" v-if="nombreInstitucion">{{nombreInstitucion}}</small>-->
                            </v-col>
                            <v-col cols="12" sm="12" md="12" class="mt-0 pt-0 pb-0 mb-0">
                               <small class="text-h6 font-italic light-blue--text darken-3--text">{{datosBoleta.nombreMunicipio}}, {{datosBoleta.nombreDepartamento}}</small>
                            <!--<small class="mt-0 pt-0" v-if="nombreInstitucion">{{nombreInstitucion}}</small>-->
                            </v-col>
                            <v-col cols="12" sm="12" md="12" class="mt-0 pt-0 mb-0">
                               {{boletaActiva ? 'Se cierra el ' : 'Se cerró el '}}  {{datosBoleta.fechaCierre | formatDate}}
                            <!--<small class="mt-0 pt-0" v-if="nombreInstitucion">{{nombreInstitucion}}</small>-->
                            </v-col>
                            <v-col cols="12" sm="12" md="12" class="mt-0 pt-0">
                               <small class="text-h6 font-italic light-blue--text darken-3--text">{{nombreEstadoBoleta}}</small>
                            <!--<small class="mt-0 pt-0" v-if="nombreInstitucion">{{nombreInstitucion}}</small>-->
                            </v-col>

                            
                        </v-row>
                    </v-col>            
                </v-row>                
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>


                
                <!-- Mostrar cunado la boleta esté en estado de segunda apertura-->
                <v-container v-if="estadoBoletaId==5" class="mb-4">

                    <v-alert
                        v-if="estadoBoletaId==5"
                        dense
                        color="cyan"
                        border="left"
                        elevation="2"
                        colored-border
                    >
                        <h3 class="text-h5 cyan--text">
                            Importante!
                        </h3>
                        <p class="text-body-1">Las respuestas pueden presentar las siguientes indicaciones:</p>
                        <p class="text-body-1"><i class="icon-lg fas fa-check" style="color: #20c997;" ></i> Sin inconsistencia (no necesita actualización)</p>
                                    
                        <p class="text-body-1"><i class="icon-lg fas fa-exclamation-triangle" style="color: #e83e8c;"></i> Con inconsistencia (necesita actualización)</p>
                        <p class="text-body-1">Atiende según corresponda</p>
                    </v-alert>
                </v-container>

                <v-row v-if="!boletaActiva" class="pr-4 mt-4">

                    <v-col cols="12" md="12">
                        <v-alert
                            outlined
                            type="error"
                            text
                            dense
                            >
                            La boleta se encuentra cerrada!
                        </v-alert>
                    </v-col>

                </v-row>

                <v-form ref="myForm"
                        v-on:submit.prevent="guardarRespuestas"
                        v-model="validForm">
                <v-row>
                    <v-col md="12" sm="12" xs="12">
                      
                        <div v-for="pregunta in preguntas" :key="pregunta.id">
                            <v-tooltip bottom style="z-index: 9999 !important;">
                                <template v-slot:activator="{ on, attrs }">
                                    <label v-bind="attrs" v-on="on" class="text-h6 font-weight-regular" style="letter-spacing:0 !important;">{{pregunta.textoPregunta}}</label>
                                </template>
                                <span>{{pregunta.descripcionPregunta}}</span>
                            </v-tooltip>

                            <!-- Inicio:: recorrer y mostrar la(s) respuesta(s) de la pregunta-->
                            <div class="pl-6" v-for="respuesta in pregunta.listaRespuestas" :key="respuesta.idRespuesta">
                                
                                <v-row>
                                    <!-- <div>
                                        estadoBoletaId: {{estadoBoletaId}} <br>
                                        estadosRevision[respuesta.idRespuesta]: {{estadosRevision[respuesta.idRespuesta]}} <br>
                                        estadosAprobacion[respuesta.idRespuesta]: {{estadosAprobacion[respuesta.idRespuesta]}} <br>
                                        textosInconsistenciaRevision[respuesta.idRespuesta]: {{textosInconsistenciaRevision[respuesta.idRespuesta]}} <br>
                                        respuesta.idRespuesta: {{ respuesta.idRespuesta }}

                                    </div> -->
                                    <div  class="col-md-1 col-sm-1 col-xs-1" style="text-align: right;">
                                        <i v-if="estadoBoletaId > 2" 
                                            :class="['icon-xl fas', 
                                                estadosRevision[respuesta.idRespuesta]==1 
                                                    ? 'fa-check' 
                                                    : estadosRevision[respuesta.idRespuesta]==2
                                                        ? 'fa-exclamation-triangle' 
                                                        : 'fa-ban' ]" 
                                            :style="estadosRevision[respuesta.idRespuesta]==1 
                                                ? 'color: #20c997; margin-top: 10px;' 
                                                : estadosRevision[respuesta.idRespuesta]==2
                                                    ? 'color: #e83e8c; margin-top: 10px;' 
                                                    : 'color: #C0C0C0; margin-top: 10px;'"  
                                        ></i>
                                       <i v-if="estadoBoletaId > 2" 
                                            :class="['icon-xl fas', 
                                                estadosAprobacion[respuesta.idRespuesta]==1 
                                                ? 'fa-check' 
                                                : estadosAprobacion[respuesta.idRespuesta]==2
                                                    ? 'fa-exclamation-triangle' 
                                                    : 'fa-ban' ]" 
                                            :style="estadosAprobacion[respuesta.idRespuesta]==1 
                                                ? 'color: #20c997; margin-top: 10px;' 
                                                : estadosAprobacion[respuesta.idRespuesta]==2
                                                    ? 'color: #e83e8c; margin-top: 10px;' 
                                                    : 'color: #C0C0C0; margin-top: 10px;'"
                                        ></i>
                                    </div>

                                    <!-- Inicio:: Si el tipo de dato es numero 1 -->
                                     <!-- actualización del disable para permitir modificación cuando el usuario no ingrese información y el revisor no asigne inconsistencia -->
                                      
                                     <!-- :disabled=" 
                                               estadosRevision[respuesta.idRespuesta] && estadosRevision[respuesta.idRespuesta] === 2 ? false : disabled[respuesta.idRespuesta] !== undefined ? disabled[respuesta.idRespuesta] : !boletaActiva ? true : false
                                            " -->
                                    <div v-if="respuesta.tipoDatoId===1" class="col-md-11 col-sm-11 col-xs-11">
                                        <v-text-field
                                            :label="respuesta.textoRespuesta"
                                            dense
                                            filled
                                            :disabled=" 
                                                !boletaActiva 
                                                    ? true
                                                    : estadosRevision[respuesta.idRespuesta] && estadosRevision[respuesta.idRespuesta] === 2
                                                        ? false
                                                        : estadosRevision[respuesta.idRespuesta] === null || estadosRevision[respuesta.idRespuesta] === undefined 
                                                            ? false : 
                                                            true
                                            "
                                            v-mask="'######'"
                                            :rules="[
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroMayorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroMayorQue[`${respuesta.idRespuesta}`] : true,
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroMenorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroMenorQue[`${respuesta.idRespuesta}`] : true,
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesObligatoria[`${respuesta.idRespuesta}`]  ?  validacionesObligatoria[`${respuesta.idRespuesta}`] : true,
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroIgualOMenorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroIgualOMenorQue[`${respuesta.idRespuesta}`] : true,
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroIgualOMayorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroIgualOMayorQue[`${respuesta.idRespuesta}`] : true,
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroIgualQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroIgualQue[`${respuesta.idRespuesta}`] : true,
                                            ]"
                                            v-model="respuestasPregunta[`${respuesta.idRespuesta}`]"
                                            :value="respuesta.idRespuesta"
                                            @input="respuesta.tipoDatoId===1 && respuesta.elementoSumatoria===1 ? sumarNumero(pregunta.preguntaId) : null"
                                            :append-icon="respuesta.elementoSumatoria===1 ? 'mdi-plus' : null"
                                        >
                                        </v-text-field>

                                    </div>

                                    <!-- Inicio:: Si el tipo de dato es moneda 2 -->
                                    <div v-if="respuesta.tipoDatoId===2" class="col-md-11 col-sm-11 col-xs-11">
                                        <v-text-field
                                            :label="respuesta.textoRespuesta"
                                            dense
                                            filled
                                            suffix="GTQ"
                                            :disabled=" 
                                                   !boletaActiva 
                                                    ? true
                                                    : estadosRevision[respuesta.idRespuesta] && estadosRevision[respuesta.idRespuesta] === 2
                                                        ? false
                                                        : estadosRevision[respuesta.idRespuesta] === null || estadosRevision[respuesta.idRespuesta] === undefined 
                                                            ? false : 
                                                            true
                                            "
                                            :rules="[
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroMayorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroMayorQue[`${respuesta.idRespuesta}`] : true,
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroMenorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroMenorQue[`${respuesta.idRespuesta}`] : true,
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesObligatoria[`${respuesta.idRespuesta}`]  ?  validacionesObligatoria[`${respuesta.idRespuesta}`] : true,
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroIgualOMenorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroIgualOMenorQue[`${respuesta.idRespuesta}`] : true,
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroIgualOMayorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroIgualOMayorQue[`${respuesta.idRespuesta}`] : true,
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroIgualQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroIgualQue[`${respuesta.idRespuesta}`] : true,
                                            ]"
                                            v-model="respuestasPregunta[`${respuesta.idRespuesta}`]"
                                            :value="respuesta.idRespuesta"
                                            @input="respuesta.tipoDatoId===1 && respuesta.elementoSumatoria===1 ? sumarNumero(pregunta.preguntaId) : null"
                                            :append-icon="respuesta.elementoSumatoria===1 ? 'mdi-plus' : null"
                                        >
                                        </v-text-field>

                                    </div>
                                    <!-- Fin:: Si el tipo de dato es moneda 2 -->

                                    <!-- Inicio:: Si el tipo de dato es texto 4 -- crear un tipo de elemento -->
                                    <div v-if="respuesta.tipoDatoId===4" class="col-md-11 col-sm-11 col-xs-11">
                                        <v-text-field
                                            :label="respuesta.textoRespuesta"
                                            dense
                                            filled
                                            :disabled=" 
                                                !boletaActiva 
                                                    ? true
                                                    : estadosRevision[respuesta.idRespuesta] && estadosRevision[respuesta.idRespuesta] === 2
                                                        ? false
                                                        : estadosRevision[respuesta.idRespuesta] === null || estadosRevision[respuesta.idRespuesta] === undefined 
                                                            ? false : 
                                                            true
                                            "
                                            :rules="[
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : respuesta.tipoDatoId==1 ? onlyInteger(respuesta.textoRespuesta) : true,
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroMayorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroMayorQue[`${respuesta.idRespuesta}`] : true,
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroMenorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroMenorQue[`${respuesta.idRespuesta}`] : true,
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesObligatoria[`${respuesta.idRespuesta}`]  ?  validacionesObligatoria[`${respuesta.idRespuesta}`] : true,
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroIgualOMenorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroIgualOMenorQue[`${respuesta.idRespuesta}`] : true,
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroIgualOMayorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroIgualOMayorQue[`${respuesta.idRespuesta}`] : true,
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroIgualQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroIgualQue[`${respuesta.idRespuesta}`] : true,
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesCantidadCaracteres[`${respuesta.idRespuesta}`]  ?  validacionesCantidadCaracteres[`${respuesta.idRespuesta}`] : true,
                                            ]"
                                            v-model="respuestasPregunta[`${respuesta.idRespuesta}`]"
                                            :value="respuesta.idRespuesta"
                                        >
                                        </v-text-field>

                                    </div>

                                    <!-- Inicio:: Si el tipo de dato es sumatoria 3 -- crear un tipo de elemento  respuesta.listaValidaciones.map(function(value, key) {
                                                    key.validacionesId === 5 ?  maxNumber(`${respuesta.textoRespuesta}`) : true
                                                }),-->
                                    <div v-if="respuesta.tipoDatoId===3" class="col-md-11 col-sm-11 col-xs-11">
                                    
                                        <v-text-field
                                            :label="respuesta.textoRespuesta"
                                            dense
                                            filled
                                            v-model="respuestasPregunta[`${respuesta.idRespuesta}`]"
                                            hint="Sumatoria"
                                            :disabled="true"
                                            append-icon="mdi-equal"
                                            :rules="[
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroMayorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroMayorQue[`${respuesta.idRespuesta}`] : true,
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroMenorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroMenorQue[`${respuesta.idRespuesta}`] : true,
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroIgualOMenorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroIgualOMenorQue[`${respuesta.idRespuesta}`] : true,
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroIgualOMayorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroIgualOMayorQue[`${respuesta.idRespuesta}`] : true,
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroIgualQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroIgualQue[`${respuesta.idRespuesta}`] : true,
                                            ]"
                                        >
                                        </v-text-field>

                                    </div>


                                    <!-- Inicio:: Si el tipo de dato es SI / NO 6, elemento de una lista 7 -- crear un tipo de elemento -->
                                    <div v-if="respuesta.tipoDatoId===6 || respuesta.tipoDatoId===7" class="col-md-11 col-sm-11 col-xs-11">

                                        <v-select
                                            :label="respuesta.textoRespuesta"
                                            dense
                                            :disabled=" 
                                                   !boletaActiva 
                                                    ? true
                                                    : estadosRevision[respuesta.idRespuesta] && estadosRevision[respuesta.idRespuesta] === 2
                                                        ? false
                                                        : estadosRevision[respuesta.idRespuesta] === null || estadosRevision[respuesta.idRespuesta] === undefined 
                                                            ? false : 
                                                            true
                                            "
                                            filled
                                            :rules="[
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesObligatoria[`${respuesta.idRespuesta}`]  ?  validacionesObligatoria[`${respuesta.idRespuesta}`] : true,
                                            ]"
                                            :items="respuesta.valoresLista"
                                            item-value="valorOpcion"
                                            item-text="textoOpcion"
                                            v-model="respuestasPregunta[`${respuesta.idRespuesta}`]"
                                            @change="respuesta.tipoDatoId===6 && respuesta.elementoSumatoria===1 ? sumarNumero(pregunta.preguntaId) : null; getDisabledEnabled(respuesta.idRespuesta, respuestasPregunta[`${respuesta.idRespuesta}`]);"
                                        >
                                        </v-select>

                                    </div>

                                    <!-- Inicio:: Si el tipo de dato es fecha 5 -- crear un tipo de elemento  respuesta.listaValidaciones.map(function(value, key) {
                                                    key.validacionesId === 5 ?  maxNumber(`${respuesta.textoRespuesta}`) : true
                                                }),-->
                                            
                                    <div v-if="respuesta.tipoDatoId===5" class="col-md-11 col-sm-11 col-xs-11">
                                    
                                        <v-text-field
                                            :label="respuesta.textoRespuesta"
                                            dense
                                            filled
                                            :disabled=" 
                                                !boletaActiva 
                                                    ? true
                                                    : estadosRevision[respuesta.idRespuesta] && estadosRevision[respuesta.idRespuesta] === 2
                                                        ? false
                                                        : estadosRevision[respuesta.idRespuesta] === null || estadosRevision[respuesta.idRespuesta] === undefined 
                                                            ? false : 
                                                            true
                                            "
                                            v-model="respuestasPregunta[`${respuesta.idRespuesta}`]"
                                            v-mask="'##/##/####'"
                                            hint="Formato dd/mm/aaaa"
                                            :rules="[
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesObligatoria[`${respuesta.idRespuesta}`]  ?  validacionesObligatoria[`${respuesta.idRespuesta}`] : true,
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : dateFormat(`${respuesta.textoRespuesta}`) ,
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesFechaPosteriorA[`${respuesta.idRespuesta}`]  ?  validacionesFechaPosteriorA[`${respuesta.idRespuesta}`] : true, 
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesFechaAnteriorA[`${respuesta.idRespuesta}`]  ?  validacionesFechaAnteriorA[`${respuesta.idRespuesta}`] : true,    
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesFechaIgualOAnteriorA[`${respuesta.idRespuesta}`]  ?  validacionesFechaIgualOAnteriorA[`${respuesta.idRespuesta}`] : true,  
                                                disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesFechaIgualOPosteriorA[`${respuesta.idRespuesta}`]  ?  validacionesFechaIgualOPosteriorA[`${respuesta.idRespuesta}`] : true,                    
                                            ]"
                                            :value="respuesta.idRespuesta"
                                        >
                                        </v-text-field>

                                    </div>

                                    

                                    <!-- Fin:: Si el tipo de dato es fecha 5-->

                                   
                                    <div  class="col-md-1 col-sm-1 col-xs-1">
                                    </div>
                                    <div  class="col-md-11 col-sm-11 col-xs-11 mt-0 pt-0" style="margin-top: -35px !important;">
                                        <p v-if="estadoBoletaId > 2 && estadosRevision[respuesta.idRespuesta] && textosInconsistenciaRevision[respuesta.idRespuesta]" class="text-subtitle-1 pink--text lighten-1--text" style="margin-top: -0px;">
                                                La respuesta presenta inconsistencia: "{{textosInconsistenciaRevision[respuesta.idRespuesta]}}".!
                                        </p>
                                    </div>

                                </v-row>

                                
                               
                            </div>


                            <!-- Inicio:: recorrer y mostrar la(s) subpreguntas del primer nivel de la pregunta-->
                            <div class="pl-6" v-for="subPregunta in pregunta.subPreguntaN1" :key="subPregunta.preguntaId">

                                
                                <v-tooltip bottom style="z-index: 9999 !important;">
                                    <template v-slot:activator="{ on, attrs }">
                                        <label v-bind="attrs" v-on="on" class="text-h6 font-weight-regular" style="letter-spacing:0 !important;">{{subPregunta.textoPregunta}}</label>
                                    </template>
                                    <span>{{subPregunta.descripcionPregunta}}</span>
                                </v-tooltip>


                                 <!-- Inicio:: recorrer y mostrar la(s) respuesta(s) de la subpregunta-->
                                <div class="pl-6" v-for="respuesta in subPregunta.listaRespuestas" :key="respuesta.idRespuesta">
                                    
                                    
                                    <v-row>

                                        <div  class="col-md-1 col-sm-1 col-xs-1" style="text-align: right;">
                                            <!-- <i v-if="estadoBoletaId > 2 && estadosRevision[respuesta.idRespuesta]" 
                                                :class="['icon-xl fas', estadosRevision[respuesta.idRespuesta]==1 
                                                    ? 'fa-check' 
                                                    : 'fa-exclamation-triangle' ]" 
                                                :style="estadosRevision[respuesta.idRespuesta]==1 
                                                    ? 'color: #20c997; margin-top: 10px;' 
                                                    : 'color: #e83e8c; margin-top: 10px;'" >
                                            </i> -->

                                            <i v-if="estadoBoletaId > 2" 
                                                :class="['icon-xl fas', estadosRevision[respuesta.idRespuesta]==1 
                                                        ? 'fa-check' 
                                                        : estadosRevision[respuesta.idRespuesta]==2
                                                            ? 'fa-exclamation-triangle' 
                                                            : 'fa-ban' ]" 
                                                :style="estadosRevision[respuesta.idRespuesta]==1 
                                                    ? 'color: #20c997; margin-top: 10px;' 
                                                    : estadosRevision[respuesta.idRespuesta]==2
                                                        ? 'color: #e83e8c; margin-top: 10px;' 
                                                        : 'color: #C0C0C0; margin-top: 10px;'"  
                                            ></i>
                                            <i v-if="estadoBoletaId > 2" 
                                                :class="['icon-xl fas', estadosAprobacion[respuesta.idRespuesta]==1 
                                                    ? 'fa-check' 
                                                    : estadosAprobacion[respuesta.idRespuesta]==2
                                                        ? 'fa-exclamation-triangle' 
                                                        : 'fa-ban' ]" 
                                                :style="estadosAprobacion[respuesta.idRespuesta]==1 
                                                    ? 'color: #20c997; margin-top: 10px;' 
                                                    : estadosAprobacion[respuesta.idRespuesta]==2
                                                        ? 'color: #e83e8c; margin-top: 10px;' 
                                                        : 'color: #C0C0C0; margin-top: 10px;'"
                                            ></i>
                                            
                                            <!--<i v-if="estadosAprobacion[respuesta.idRespuesta]" :class="['icon-xl fas', estadosAprobacion[respuesta.idRespuesta]==1 ? 'fa-check' : 'fa-exclamation-triangle' ]" :style="estadosAprobacion[respuesta.idRespuesta]==1 ? 'color: #20c997; margin-top: 10px;' : 'color: #e83e8c; margin-top: 10px;'"></i>-->
                                        </div>

                                        <!-- Inicio:: Si el tipo de dato es numero 1 -->
                                        <div v-if="respuesta.tipoDatoId===1" class="col-md-11 col-sm-11 col-xs-11">
                                        

                                            <v-text-field
                                                :label="respuesta.textoRespuesta "
                                                dense
                                                filled
                                                :disabled=" 
                                                    !boletaActiva 
                                                    ? true
                                                    : estadosRevision[respuesta.idRespuesta] && estadosRevision[respuesta.idRespuesta] === 2
                                                        ? false
                                                        : estadosRevision[respuesta.idRespuesta] === null || estadosRevision[respuesta.idRespuesta] === undefined 
                                                            ? false : 
                                                            true
                                                "
                                                v-mask="'######'"
                                                :rules="[
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroMayorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroMayorQue[`${respuesta.idRespuesta}`] : true,
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroMenorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroMenorQue[`${respuesta.idRespuesta}`] : true,
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesObligatoria[`${respuesta.idRespuesta}`]  ?  validacionesObligatoria[`${respuesta.idRespuesta}`] : true,
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroIgualOMenorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroIgualOMenorQue[`${respuesta.idRespuesta}`] : true,
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroIgualOMayorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroIgualOMayorQue[`${respuesta.idRespuesta}`] : true,
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroIgualQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroIgualQue[`${respuesta.idRespuesta}`] : true,
                                                ]"
                                                v-model="respuestasPregunta[`${respuesta.idRespuesta}`]"
                                                :value="respuesta.idRespuesta"
                                                @input="respuesta.tipoDatoId===1 && respuesta.elementoSumatoria===1 ? sumarNumero(subPregunta.preguntaId) : null"
                                                :append-icon="respuesta.elementoSumatoria===1 ? 'mdi-plus' : null"
                                            >
                                            </v-text-field>

                                        </div>

                                        <!-- Inicio:: Si el tipo de dato es moneda 2 -->
                                        <div v-if="respuesta.tipoDatoId===2" class="col-md-11 col-sm-11 col-xs-11">
                                            <v-text-field
                                                :label="respuesta.textoRespuesta"
                                                dense
                                                filled
                                                suffix="GTQ"
                                                :disabled=" 
                                                    !boletaActiva 
                                                    ? true
                                                    : estadosRevision[respuesta.idRespuesta] && estadosRevision[respuesta.idRespuesta] === 2
                                                        ? false
                                                        : estadosRevision[respuesta.idRespuesta] === null || estadosRevision[respuesta.idRespuesta] === undefined 
                                                            ? false : 
                                                            true
                                                "
                                                :rules="[
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroMayorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroMayorQue[`${respuesta.idRespuesta}`] : true,
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroMenorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroMenorQue[`${respuesta.idRespuesta}`] : true,
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesObligatoria[`${respuesta.idRespuesta}`]  ?  validacionesObligatoria[`${respuesta.idRespuesta}`] : true,
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroIgualOMenorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroIgualOMenorQue[`${respuesta.idRespuesta}`] : true,
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroIgualOMayorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroIgualOMayorQue[`${respuesta.idRespuesta}`] : true,
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroIgualQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroIgualQue[`${respuesta.idRespuesta}`] : true,
                                                ]"
                                                v-model="respuestasPregunta[`${respuesta.idRespuesta}`]"
                                                :value="respuesta.idRespuesta"
                                                @input="respuesta.tipoDatoId===1 && respuesta.elementoSumatoria===1 ? sumarNumero(pregunta.preguntaId) : null"
                                                :append-icon="respuesta.elementoSumatoria===1 ? 'mdi-plus' : null"
                                            >
                                            </v-text-field>

                                        </div>
                                        <!-- Fin:: Si el tipo de dato es moneda 2 -->


                                        <!-- Inicio:: Si el tipo de dato es texto 4 -- crear un tipo de elemento -->
                                        <div v-if="respuesta.tipoDatoId===4" class="col-md-11 col-sm-11 col-xs-11">
                                        
<!-- estadosRevision[respuesta.idRespuesta] && estadosRevision[respuesta.idRespuesta] === 2 ? false : disabled[respuesta.idRespuesta]  !== undefined ? disabled[respuesta.idRespuesta] : !boletaActiva ? true : false -->
                                            <v-text-field
                                                :label="respuesta.textoRespuesta"
                                                dense
                                                filled
                                                :disabled=" 
                                                    !boletaActiva 
                                                        ? true
                                                        : estadosRevision[respuesta.idRespuesta] && estadosRevision[respuesta.idRespuesta] === 2
                                                            ? false
                                                            : estadosRevision[respuesta.idRespuesta] === null || estadosRevision[respuesta.idRespuesta] === undefined 
                                                                ? false : 
                                                                true
                                                "
                                                :rules="[
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : respuesta.tipoDatoId==1 ? onlyInteger(respuesta.textoRespuesta) : true,
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroMayorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroMayorQue[`${respuesta.idRespuesta}`] : true,
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroMenorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroMenorQue[`${respuesta.idRespuesta}`] : true,
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesObligatoria[`${respuesta.idRespuesta}`]  ?  validacionesObligatoria[`${respuesta.idRespuesta}`] : true,
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroIgualOMenorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroIgualOMenorQue[`${respuesta.idRespuesta}`] : true,
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroIgualOMayorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroIgualOMayorQue[`${respuesta.idRespuesta}`] : true,
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroIgualQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroIgualQue[`${respuesta.idRespuesta}`] : true,
                                                ]"
                                                v-model="respuestasPregunta[`${respuesta.idRespuesta}`]"
                                                :value="respuesta.idRespuesta"
                                                
                                            >
                                            </v-text-field>

                                        </div>

                                        <!-- Inicio:: Si el tipo de dato es sumatoria 3 -- crear un tipo de elemento  respuesta.listaValidaciones.map(function(value, key) {
                                                    key.validacionesId === 5 ?  maxNumber(`${respuesta.textoRespuesta}`) : true
                                                }),-->
                                        <div v-if="respuesta.tipoDatoId===3" class="col-md-11 col-sm-11 col-xs-11">
                                        
                                            <v-text-field
                                                :label="respuesta.textoRespuesta"
                                                dense
                                                :value="respuestasPregunta[`${respuesta.idRespuesta}`]"
                                                filled
                                                v-model="respuestasPregunta[`${respuesta.idRespuesta}`]"
                                                hint="Sumatoria"
                                                :disabled="true"
                                                append-icon="mdi-equal"
                                                :rules="[
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroMayorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroMayorQue[`${respuesta.idRespuesta}`] : true,
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroMenorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroMenorQue[`${respuesta.idRespuesta}`] : true,
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroIgualOMenorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroIgualOMenorQue[`${respuesta.idRespuesta}`] : true,
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroIgualOMayorQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroIgualOMayorQue[`${respuesta.idRespuesta}`] : true,
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesNumeroIgualQue[`${respuesta.idRespuesta}`]  ?  validacionesNumeroIgualQue[`${respuesta.idRespuesta}`] : true,
                                                ]"
                                            >
                                            </v-text-field>

                                        </div>

                                        <!-- Inicio:: Si el tipo de dato es fecha 5 -- crear un tipo de elemento  respuesta.listaValidaciones.map(function(value, key) {
                                                key.validacionesId === 5 ?  maxNumber(`${respuesta.textoRespuesta}`) : true
                                            }),-->
                                        <div v-if="respuesta.tipoDatoId===5" class="col-md-11 col-sm-11 col-xs-11">
                                        <!-- estadosRevision[respuesta.idRespuesta] && estadosRevision[respuesta.idRespuesta] === 2 ? false : disabled.hasOwnProperty(respuesta.idRespuesta) ? disabled[respuesta.idRespuesta] : !boletaActiva ? true : false -->
                                            <v-text-field
                                                :label="respuesta.textoRespuesta"
                                                dense
                                                filled
                                                :disabled=" 
                                                    !boletaActiva 
                                                            ? true
                                                            : estadosRevision[respuesta.idRespuesta] && estadosRevision[respuesta.idRespuesta] === 2
                                                                ? false
                                                                : estadosRevision[respuesta.idRespuesta] === null || estadosRevision[respuesta.idRespuesta] === undefined 
                                                                    ? false : 
                                                                    true
                                                "
                                                v-model="respuestasPregunta[`${respuesta.idRespuesta}`]"
                                                v-mask="'##/##/####'"
                                                hint="Formato dd/mm/aaaa"
                                                :rules="[
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesObligatoria[`${respuesta.idRespuesta}`]  ?  validacionesObligatoria[`${respuesta.idRespuesta}`] : true,
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : dateFormat(`${respuesta.textoRespuesta}`) ,
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesFechaPosteriorA[`${respuesta.idRespuesta}`]  ?  validacionesFechaPosteriorA[`${respuesta.idRespuesta}`] : true, 
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesFechaAnteriorA[`${respuesta.idRespuesta}`]  ?  validacionesFechaAnteriorA[`${respuesta.idRespuesta}`] : true,    
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesFechaIgualOAnteriorA[`${respuesta.idRespuesta}`]  ?  validacionesFechaIgualOAnteriorA[`${respuesta.idRespuesta}`] : true,  
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesFechaIgualOPosteriorA[`${respuesta.idRespuesta}`]  ?  validacionesFechaIgualOPosteriorA[`${respuesta.idRespuesta}`] : true,
                                                                            
                                                ]"
                                            >
                                            </v-text-field>

                                        </div>

                                    
                                        <!-- Inicio:: Si el tipo de dato es SI / NO 6, elemento de una lista 7 -- crear un tipo de elemento -->

                                        <!-- ********************* el disabled se desactivo porque no permite actualizar las preguntas despues del primer ingreso ******************* RH -->

                                        <!-- ********************* El v-show se invirtio del disabled ******************* RH -->
                                         <!-- :disabled2=" 
                                                    estadosAprobacion[respuesta.idRespuesta] ? true : estadosRevision[respuesta.idRespuesta] && estadosRevision[respuesta.idRespuesta] === 2 ?  false : disabled[respuesta.idRespuesta] !== undefined ? disabled[respuesta.idRespuesta] : !boletaActiva ? true : false
                                                "

                                                :disabled=" 
                                                    estadosAprobacion[respuesta.idRespuesta] ? false : estadosRevision[respuesta.idRespuesta] && estadosRevision[respuesta.idRespuesta] === 2 ?  false : disabled[respuesta.idRespuesta] !== undefined ? disabled[respuesta.idRespuesta] : !boletaActiva ? true : false
                                                " -->

                                        <div v-if="respuesta.tipoDatoId===6 || respuesta.tipoDatoId===7" class="col-md-11 col-sm-11 col-xs-11">
                                            
                                            <v-select
                                                :label="respuesta.textoRespuesta"
                                                dense
                                                
                                                :disabled=" 
                                                    !boletaActiva 
                                                            ? true
                                                            : estadosRevision[respuesta.idRespuesta] && estadosRevision[respuesta.idRespuesta] === 2
                                                                ? false
                                                                : estadosRevision[respuesta.idRespuesta] === null || estadosRevision[respuesta.idRespuesta] === undefined 
                                                                    ? false : 
                                                                    true
                                                "
                                                
                                                
                                                
                                                
                                                
                                                filled
                                                :rules="[
                                                    disabled[respuesta.idRespuesta] && disabled[respuesta.idRespuesta] ==true ? true : validacionesObligatoria[`${respuesta.idRespuesta}`]  ?  validacionesObligatoria[`${respuesta.idRespuesta}`] : true,
                                                ]"
                                                :items="respuesta.valoresLista"
                                                item-value="valorOpcion"
                                                item-text="textoOpcion"
                                                v-model="respuestasPregunta[`${respuesta.idRespuesta}`]"
                                                @change="respuesta.tipoDatoId===6 && respuesta.elementoSumatoria===1 ? sumarNumero(subPregunta.preguntaId) : null; getDisabledEnabled(respuesta.idRespuesta, respuestasPregunta[`${respuesta.idRespuesta}`]);"
                                            >
                                            </v-select>

                                        </div>
                                       
                                        <div  class="col-md-1 col-sm-1 col-xs-1">
                                        </div>
                                        <div  class="col-md-11 col-sm-11 col-xs-11 mt-0 pt-0 pb-0" style="margin-top: -35px !important; margin-bottom: -20px !important;">
                                            <p v-if="estadoBoletaId > 2 && estadosRevision[respuesta.idRespuesta] && textosInconsistenciaRevision[respuesta.idRespuesta]" class="text-subtitle-1 pink--text lighten-1--text" style="margin-top: -0px;">
                                                    La respuesta presenta inconsistencia: "{{textosInconsistenciaRevision[respuesta.idRespuesta]}}".!
                                            </p>
                                        </div>
                                        
                                    </v-row>

                                </div>
                                <!-- Fin:: recorrer y mostrar la(s) respuesta(s) de la subpregunta-->


                                

                            </div>
                            <!-- Fin:: recorrer y mostrar la(s) subpreguntas del primer nivel de la pregunta-->

                            <!--<SubHeader subHeaderTitle=" " />-->
                            <!-- Fin:: recorrer y mostrar la(s) respuesta(s) de la pregunta-->

                            <div style="background: #f0f0f0;" class="pl-4 pr-4">
                                <template v-if="pregunta.listaMediosVerificacion.length > 0">
                                    <SubHeader subHeaderTitle="Medios de verificación " />
                                </template>
                                
                                <!--Inicio:: recorrer y mostrar el (los) medio(s) de verificación de la pregunta-->
                                <div class="pl-6" v-for="medioVerificacion in pregunta.listaMediosVerificacion" :key="medioVerificacion.id">
                                    <v-row>

                                        <v-overlay
                                            :opacity="1"
                                            :value="mediosLoading"
                                            >
                                            <v-progress-circular indeterminate size="64">
                                                Cargado Medios de verificación...
                                            </v-progress-circular>
                                        </v-overlay>

                                         
                                            
                                        <v-row v-if="mediosPregunta[`${medioVerificacion.medioVerificacionId}`]" class="pr-4">

                                            <v-col cols="12" md="12">
                                                <v-alert
                                                    outlined
                                                    type="success"
                                                    text
                                                    dense
                                                    >
                                                    Ya se ha cargado el medio de verificación {{medioVerificacion.codigo}} para la pregunta, puedes descargarlo o cargar uno nuevo.
                                                </v-alert>

                                                <!--
                                                <v-btn class="ma-2" tile outlined color="indigo"
                                                    @click="descargarArchivo(`${baseIntUrl}${mediosPregunta[medioVerificacion.medioVerificacionId]}`)">
                                                    <v-icon left>mdi-cloud-download</v-icon> Descargar Medio
                                                </v-btn>
                                                -->
                                                
                                                <v-btn class="ma-2" tile outlined color="indigo"
                                                    @click="descargarArchivo(`https://ranking.segeplan.gob.gt${mediosPregunta[medioVerificacion.medioVerificacionId]}`)">
                                                    <v-icon left>mdi-cloud-download</v-icon> Descargar Medio
                                                </v-btn>

                                            </v-col>

                                        </v-row>
                                            
                                            
                                        


                                        <v-col cols="12" md="12" class="pb-0" style="margin-bottom: -2px;">
                                            
                                            <v-tooltip bottom style="z-index: 9999 !important;">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <label v-bind="attrs" v-on="on" class="text-h6 font-weight-regular" style="letter-spacing:0 !important;">{{medioVerificacion.nombre}}</label>
                                                </template>
                                                <span class="text-h5">{{medioVerificacion.descripcion}}</span>
                                            </v-tooltip>
                                        </v-col>

                                        
                                        <v-col v-if="medioVerificacion.principal=='SI' && boletaActiva" cols="12" md="8" sm="8" class="pt-0">
                                            <v-file-input
                                                :id="`mvFile${medioVerificacion.medioVerificacionId}`"
                                                :ref="`mvFile${medioVerificacion.medioVerificacionId}`"
                                                accept="application/pdf,image/jpeg"
                                                append-icon="mdi-file-pdf-outline"
                                                dense
                                                v-model="archivosMV[medioVerificacion.medioVerificacionId]"
                                                hint="Selecciona un archivo jpg o pdf para el medio de verificación. Peso máximo 25Mb"
                                                label="Seleccionar archivo"
                                                outlined
                                                prepend-icon=""
                                                @change="onFileChange($event, medioVerificacion.medioVerificacionId, `mvFile${medioVerificacion.medioVerificacionId}`)"
                                                :show-size="1000">
                                                <template v-slot:selection="{ index, text }">
                                                        <v-chip
                                                            v-if="index < 2"
                                                            small
                                                            label
                                                            :color="archivoValido[medioVerificacion.medioVerificacionId] ? 'primary' : 'error'"
                                                        >
                                                            {{ text }}
                                                        </v-chip>
                                                        <span
                                                            v-else-if="index === 2"
                                                            class="text-overline grey--text text--darken-3 mx-2"
                                                        >
                                                            +{{ files.length - 2 }} archivo(s)
                                                        </span>
                                                    </template>
                                            </v-file-input>
                                        </v-col>
                                        <v-col v-if="medioVerificacion.principal=='SI' && boletaActiva" cols="12" md="4" sm="4" class="pt-0 text-left">
                                            <v-btn color="blue-grey" class="white--text"  :disabled="!archivoValido[medioVerificacion.medioVerificacionId]"
                                                @click="guardarMedio(medioVerificacion.medioVerificacionId)">
                                                <v-icon left>mdi-cloud-upload</v-icon> {{mediosPregunta[medioVerificacion.medioVerificacionId] ? 'Cargar de nuevo' : 'Cargar MV'}}
                                            </v-btn>
                                        </v-col>
                                        
                                    </v-row>

                                    <v-divider v-if="pregunta.listaMediosVerificacion.length > 1" class="pt-4 pb-4"></v-divider>
                                </div>
                                <!-- Fin:: recorrer y mostrar el (los) medio(s) de verificación de la pregunta-->
                            </div>
                            <v-divider class="mt-8 mb-8"></v-divider>
                        </div>
                    </v-col>


                    <v-container>
                        <v-row v-if="!validForm">
                            <v-col md="12">
                                <v-alert
                                    text
                                    dense
                                    type="error"
                                
                                    >
                                        Existen respuestas no completadas o inconsistentes, por favor, revisa la información.
                                    </v-alert>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col md="12">
                                <v-btn
                                    
                                    color="primary"
                                    class="mb-2 float-right"
                                    type="submit"
                                    :elevation="0" 
                                    :loading="btnRegistroLoading" 
                                    :disabled="!validForm || btnRegistroLoading || !boletaActiva"
                                    >
                                    <v-icon left>
                                        mdi-content-save
                                    </v-icon>
                                    Guardar Respuestas
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-row>
                </v-form>
            </v-card-text>
         </v-card>
         <!--Fin:: v-card-->


        <!--Dialog loader -->
        <DialogLoader
            :dialogVisible="dialogLoaderVisible"
            :text="dialogLoaderText"
        ></DialogLoader>
        <!---->


         <!--Inicio:: Snack alert-->
        <SnackAlert ref="snackalert"></SnackAlert>
        <!-- Fin:: Snack alert-->

        

    </div>
    
</template>
<script>
import Vue from 'vue';
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import SubHeader from "@/view/components/subheader/SubHeader";
import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";
import moment from "moment";
import validations from "@/core/untils/validations.js";
import { API_BASE_URL } from "@/core/services/api.service";

import {OBTENER_BOLETA_MUNI} from "@/core/services/store/boletas/boletamuni.module";

import {OBTENER_PREGUNTAS_PERIODO_BOLETA} from "@/core/services/store/preguntasperiodoboleta/preguntaperiodoboleta.module";

import {OBTENER_RESPUESTAS_MUNI, REGISTRAR_RESPUESTAS_MUNI} from "@/core/services/store/respuestasmuni/respuestamuni.module";

import { OBTENER_MEDIOS_VERIFICACION_PREGUNTA_MUNI, REGISTRAR_MEDIO_VERIFICACION_PREGUNTA_MUNI } from "@/core/services/store/respuestasmuni/medioverificacionmuni.module";

import { CARGAR_ARCHIVO } from "@/core/services/store/cargaarchivo.module";

moment.locale('es');
Vue.filter("formatDate", function(value) {
    if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
    }
});


export default {
name: 'ResponderBoleta',
components: {
        SubHeader, 
        SnackAlert,
        DialogLoader
    },
    data() {
        return {
            baseIntUrl:'',
            boletaActiva: true,
            validForm:false,
            cardPreguntasLoading:false,
            btnRegistroLoading:false,
            dialogLoaderVisible: false,
            dialogLoaderText: 'Actualizando información...',
            respuestaIndex:1,
            datosBoleta: [],
            preguntas:[],
            respuestasPregunta:{},
            estadosRevision:{},
            estadosAprobacion:{},
            textosInconsistenciaRevision: {},
            reglasPregunta:[],
            testRespuestasPregunta:[],
            respuestasRegistradas:[],
            boletaSeleccionada:0,
            periodoSeleccionado:0,
            boletaMunicipalidadId:0,
            parameters:[],
            listRespuestasMuni:[],
            datosRespuesta:{
                boletaMunicipalidadId:0,
                estadosId:1,
                listRespuestasMuni:[],
            },
            estadoBoletaId:0,
            nombreEstadoBoleta:'',
            //Medios de verificacion
            mediosLoading: false,
            mediosAsignados:[],
            mediosPregunta:{}, //Almacena el id del medio junto con el path
            archivoValido: [],
            archivoCargado:false,
            archivosMV: [],
            archivoMV:[],
            datosMedio:{
                path:null,
                mediosVerificacionPreguntaId: 0,
                boletaMunicipalidadId: this.boletaMunicipalidadId,
                nombreArchivo: null,
                estadosId: 1,
            },
            uploadReady: true,
            //Validaciones por tipo
            validacionesCantidadCaracteres:[],
            validacionesFechaAnteriorA: [],
            validacionesFechaPosteriorA: [],
            validacionesNumeroMayorQue: [],
            validacionesNumeroMenorQue: [],
            validacionesObligatoria: [],
            validacionesRangoFechas: [],
            validacionesRangoNumerico: [],
            validacionesFechaIgualA: [],
            validacionesFechaIgualOAnteriorA: [],
            validacionesFechaIgualOPosteriorA: [],
            validacionesNumeroIgualQue: [],
            validacionesNumeroIgualOMayorQue: [],
            validacionesNumeroIgualOMenorQue: [],
            validacionesdisponibleSoloSi: [],
            validacionesObligatoriaSoloSi: [],
            disponibleSoloSiGeneral:[], //Para habilitar o desabilitar conrtroles cuando el tipo de validacion sea 14
            disponibleSoloSi:[],
            disabled:[],
            res1Rules:[],
            ...validations
        }
    },

    methods:{

    //!Obtener la información de la boleta que está respondiendo
    async obtenerDatosBoleta(){
        this.datosBoleta = [];
        await this.$store
            .dispatch(OBTENER_BOLETA_MUNI, this.boletaMunicipalidadId )
            .then(res => {
                
                if(res.status===200){
                    this.datosBoleta = res.data;
                    this.datosBoleta.estadosBoletaId == 2 || this.datosBoleta.estadosBoletaId == 5 ? this.boletaActiva = true : this.boletaActiva = false; 
                    this.estadoBoletaId = this.datosBoleta.estadosBoletaId;
                    this.nombreEstadoBoleta = this.datosBoleta.nombre;
                }
            })
            .catch(err => {
                console.warn(err)
            });
        
    },



     //!Obtener el listado de preguntas por índice
      async obtenerPreguntasPorIndice(){
          this.cardPreguntasLoading=true;
          this.preguntas=[];
            await this.$store
            .dispatch(OBTENER_PREGUNTAS_PERIODO_BOLETA, {boletaId:this.boletaSeleccionada, periodoId: this.periodoSeleccionado})
            .then(res => {
                
                if(res.status===200){
                    this.preguntas = res.data;
                   // console.log(this.preguntas)

                    // ASIGNAR LAS VALIDACIONES PARA CADA RESPUESTA
                    this.preguntas.forEach(element => {
                        
                        element.listaRespuestas.forEach(respuestas1 => {
                        
                            
                            for(var key of Object.keys(respuestas1.listaValidaciones)){
                                //let tempElement = {};
                                
                                //this.disabled[respuestas1.idRespuesta] = false;
                                this.asignarValidacionesRespuesta(respuestas1, key );
                                

                            }

           
                            // this.respuestasPregunta[`${respuestas1.idRespuesta}`] = tempValidaciones1;
                             //console.log(this.reglasPregunta);
                        });

                        //Subpreguntas Nivel 1
                        element.subPreguntaN1.forEach(preguntas2 => {
                            //console.log(preguntas2)

                            preguntas2.listaRespuestas.forEach(respuestas2 => {

                                for(var key of Object.keys(respuestas2.listaValidaciones)){
                                    //let tempElement = {};
                                    //console.log(respuestas2)
                                   // this.disabled[respuestas2.idRespuesta] = false;
                                    this.asignarValidacionesRespuesta(respuestas2, key );
                                    

                                }
                            });


                        });


                    })


                } else {
                    //console.warn(res.message)
                    this.tableNoDataText = 'No se encontraron preguntas para el índice seleccionado';
                }
                this.cardPreguntasLoading=false;
            })
            .catch(()=> {
                this.cardPreguntasLoading=false;
                this.tableNoDataText = 'No se encontraron preguntas para el índice seleccionado';
                //console.log(err)
                });

      },


      asignarValidacionesRespuesta(respuestas1, key){

        // 1 | cantidad de caracteres
        if(respuestas1.listaValidaciones[key].validacionesId===2){
        
            let valorComp = parseInt(respuestas1.listaValidaciones[key].valorDefinido);

            const rule = v => v.length <= valorComp || `Máximo número de caracteres sobrepasado  ${valorComp} para la respuesta`;

            let tempValidaciones1 =new Array();
            tempValidaciones1.push(rule);

            let keyName = respuestas1.listaValidaciones[key].respuestasId;
            this.validacionesCantidadCaracteres[keyName] = tempValidaciones1[0];
        
        }

        // 2 | Fecha anterior a
        if(respuestas1.listaValidaciones[key].validacionesId===2){
        
            let valorComp = respuestas1.listaValidaciones[key].valorDefinido;
           // console.log(valorComp)

            const rule = v =>moment(v, "DD-MM-YYYY").diff(moment(valorComp, "DD-MM-YYYY")) < 0 || `La fecha ingresada debe ser anterior a ${valorComp}`;

            let tempValidaciones1 =new Array();
            tempValidaciones1.push(rule);

            let keyName = respuestas1.listaValidaciones[key].respuestasId;
            this.validacionesFechaAnteriorA[keyName] = tempValidaciones1[0];

            
        
        }
         
        // 3 | Fecha posterior a
        if(respuestas1.listaValidaciones[key].validacionesId===3){
        
            let valorComp = respuestas1.listaValidaciones[key].valorDefinido;

            const rule = v =>moment(valorComp, "DD-MM-YYYY").diff(moment(v, "DD-MM-YYYY")) < 0 || `La fecha ingresada debe ser posterior a ${valorComp}`;

            let tempValidaciones1 =new Array();
            tempValidaciones1.push(rule);

            let keyName = respuestas1.listaValidaciones[key].respuestasId;
            this.validacionesFechaPosteriorA[keyName] = tempValidaciones1[0];
        
        }

        // 4 | Número mayor que
        if(respuestas1.listaValidaciones[key].validacionesId===4){
            //let tempElement = {};
            let valorComp = parseInt(respuestas1.listaValidaciones[key].valorDefinido);
            const rule =
            v =>(v && v > valorComp) || `El número ingresado para  debe ser mayor a ${valorComp}`;
            let tempValidaciones1 =new Array();
            tempValidaciones1.push(rule);

            // console.log(respuestas1.listaValidaciones[key].validacionesId)
            let keyName = respuestas1.listaValidaciones[key].respuestasId;
            this.validacionesNumeroMayorQue[keyName] = tempValidaciones1[0];                                   
        }
            
        //5 | Número menor que
        if(respuestas1.listaValidaciones[key].validacionesId===5){

            let valorComp = parseInt(respuestas1.listaValidaciones[key].valorDefinido);
            const rule =
            v =>(v && v <= valorComp) || `El número ingresado para  debe ser menor a ${valorComp}`;
            let tempValidaciones1 =new Array();
            tempValidaciones1.push(rule);

            // console.log(respuestas1.listaValidaciones[key].validacionesId)
            let keyName = respuestas1.listaValidaciones[key].respuestasId;
            this.validacionesNumeroMenorQue[keyName] = tempValidaciones1[0];

            //this.reglasPregunta.push(tempElement);
            //this.reglasPregunta.push(tempElement);
            //console.log(this.reglasPregunta);
            //console.log(respuestas1.listaValidaciones[key].respuestasId)
        }

        


        // 6 | Obligatoria
       if(respuestas1.listaValidaciones[key].validacionesId===6){
            //let tempElement = {};
            //console.log("lleva")
            let valorComp = respuestas1.listaValidaciones[key].valorDefinido;

            if(valorComp=="SI" || valorComp=="1") {
                //console.log(key)
                const rule =
                v => !!v || `El campo ${respuestas1.textoRespuesta} es obligatorio`;
                let tempValidaciones1 =new Array();
                tempValidaciones1.push(rule);

               // console.log(respuestas1.listaValidaciones[key].validacionesId)
                let keyName = respuestas1.listaValidaciones[key].respuestasId;
                this.validacionesObligatoria[keyName] = tempValidaciones1[0];

            
            }
            
        }


        // 9 | Fecha igual a
        if(respuestas1.listaValidaciones[key].validacionesId===9){
        
            let valorComp = respuestas1.listaValidaciones[key].valorDefinido;

            const rule = v =>moment(v, "DD-MM-YYYY").diff(moment(valorComp, "DD-MM-YYYY")) == 0 || `La fecha ingresada debe ser igual a ${valorComp}`;

            let tempValidaciones1 =new Array();
            tempValidaciones1.push(rule);

            let keyName = respuestas1.listaValidaciones[key].respuestasId;
            this.validacionesFechaIgualA[keyName] = tempValidaciones1[0];
        
        }


        // 10 | Fecha igual o anterior a
        if(respuestas1.listaValidaciones[key].validacionesId===10){
        
            let valorComp = respuestas1.listaValidaciones[key].valorDefinido;

             let rule = null;

            if(respuestas1.listaValidaciones[key].tipoRespuestaId==2){

                let idR = respuestas1.listaValidaciones[key].respuestasIdValorSeleccionado;
                rule = v =>moment(v, "DD-MM-YYYY").diff(moment(this.respuestasPregunta[idR], "DD-MM-YYYY")) <= 0 || `La fecha ingresada debe ser igual o anterior a ${this.respuestasPregunta[idR]}`;
            }
            else{

                rule = v =>moment(v, "DD-MM-YYYY").diff(moment(valorComp, "DD-MM-YYYY")) <= 0 || `La fecha ingresada debe ser igual o anterior a ${valorComp}`;
            }

            let tempValidaciones1 =new Array();
            tempValidaciones1.push(rule);

            let keyName = respuestas1.listaValidaciones[key].respuestasId;
            this.validacionesFechaIgualOAnteriorA[keyName] = tempValidaciones1[0];
        
        }

        // 11 | Fecha igual o posterior a
        if(respuestas1.listaValidaciones[key].validacionesId===11){
        
            let valorComp = respuestas1.listaValidaciones[key].valorDefinido;
            
            let rule = null;

            if(respuestas1.listaValidaciones[key].tipoRespuestaId==2){

                let idR = respuestas1.listaValidaciones[key].respuestasIdValorSeleccionado;
                rule = v =>moment(v, "DD-MM-YYYY").diff(moment(this.respuestasPregunta[idR], "DD-MM-YYYY")) >= 0 || `La fecha ingresada debe ser igual o posterior a ${this.respuestasPregunta[idR]}`;
            }
            else{
             rule = v =>moment(v, "DD-MM-YYYY").diff(moment(valorComp, "DD-MM-YYYY")) >= 0 || `La fecha ingresada debe ser igual o posterior a ${valorComp}`;
            }

            let tempValidaciones1 =new Array();
            tempValidaciones1.push(rule);

            let keyName = respuestas1.listaValidaciones[key].respuestasId;
            this.validacionesFechaIgualOPosteriorA[keyName] = tempValidaciones1[0];
        
        }



        // 12 | Número igual que
        if(respuestas1.listaValidaciones[key].validacionesId===12){
            //let tempElement = {};
            let valorComp = Number(respuestas1.listaValidaciones[key].valorDefinido);

            
            const rule =
            v =>(v && v == valorComp) || `El número ingresado para  debe ser igual que ${valorComp}`;
            let tempValidaciones1 =new Array();
            tempValidaciones1.push(rule);

            let keyName = respuestas1.listaValidaciones[key].respuestasId;
            this.validacionesNumeroIgualQue[keyName] = tempValidaciones1[0];
            
            
        }


        // 13 | Número igual o mayor que
        if(respuestas1.listaValidaciones[key].validacionesId===13){
            //let tempElement = {};
            let valorComp = Number(respuestas1.listaValidaciones[key].valorDefinido);
            //console.log(respuestas1.listaValidaciones[key])

             let rule = null;

            //!Validar que el valor a comparar sea a partir de otra respuesta

            if(respuestas1.listaValidaciones[key].tipoRespuestaId==2){

                let idR = respuestas1.listaValidaciones[key].respuestasIdValorSeleccionado;
                rule =
                    v =>(v && v >= Number(this.respuestasPregunta[idR])) || `El número ingresado para  debe ser mayor o igual que ${this.respuestasPregunta[idR]}`;
            }
            else{
                rule =
                v =>(v && v >= valorComp) || `El número ingresado debe ser mayor o igual que ${valorComp}`;
            }
            let tempValidaciones1 =new Array();
            tempValidaciones1.push(rule);

            let keyName = respuestas1.listaValidaciones[key].respuestasId;
            this.validacionesNumeroIgualOMayorQue[keyName] = tempValidaciones1[0];
            
            
        }

        // 14 | Numero igual o menor que
        if(respuestas1.listaValidaciones[key].validacionesId===14){
    
            let valorComp = Number(respuestas1.listaValidaciones[key].valorDefinido);

             let rule = null;
            //!Validar que el valor a comparar sea a partir de otra respuesta

            if(respuestas1.listaValidaciones[key].tipoRespuestaId==2){

                let idR = respuestas1.listaValidaciones[key].respuestasIdValorSeleccionado;
                rule =
                    v =>(v && v <= Number(this.respuestasPregunta[idR])) || `El número ingresado debe ser menor o igual que ${this.respuestasPregunta[idR]}`;
            }else{

                rule = v =>(v && v <= valorComp) || `El número ingresado debe ser menor o igual que ${valorComp}`;
            
            }
            let tempValidaciones1 =new Array();
            tempValidaciones1.push(rule);

            let keyName = respuestas1.listaValidaciones[key].respuestasId;
            this.validacionesNumeroIgualOMenorQue[keyName] = tempValidaciones1[0];
        }


         // 15 | Disponible solo si
        if(respuestas1.listaValidaciones[key].validacionesId===15){
    
            //let valorComp = parseInt(respuestas1.listaValidaciones[key].valorDefinido);
            //?Validar que la opción seleccionada sea del valor de otra respueta
            if(respuestas1.listaValidaciones[key].tipoRespuestaId===2){
                /*let respuestaReferenciaId = respuestas1.listaValidaciones[key].respuestasIdValorSeleccionado;
                let tempValidaciones1 =new Array();
                tempValidaciones1.push({respuestaId: respuestas1.listaValidaciones[key].respuestasId, respuestaReferenciaId: respuestaReferenciaId, valorComparacion: valorComp });               
                //console.log(tempValidaciones1)
                let keyName = respuestas1.listaValidaciones[key].respuestasId;
                this.disponibleSoloSiGeneral[keyName] = tempValidaciones1[0];*/

                let keyName = respuestas1.listaValidaciones[key].respuestasId;
                let tempValidacionesE =new Array();
                tempValidacionesE.push(true);
                this.disabled[keyName] = tempValidacionesE[0];

                 //console.log(respuestas1.listaValidaciones[key].respuestasId)
            }
        }
        
      },

      sumIndex(){
          this.respuestaIndex++;
          return this.respuestaIndex;
      },
    
    //!Obtener las respuestas de la municipalidad previamente guardadas
    async obtenerRespuestasMunicipalidad(){
        

         //this.tableLoading = true;
            this.respuestasRegistradas=[];
            //console.log('22')
            await this.$store
                .dispatch(OBTENER_RESPUESTAS_MUNI, this.boletaMunicipalidadId)
                .then(res => {
                    if(res.status===200){
                        this.respuestasRegistradas = this.$store.state.respuestamuni.respuestasMuni;

                        console.log(this.respuestasRegistradas)
                        //console.log(this.$store.state.respuestamuni.respuestasMuni)
                        let map = {};
                        let mapRevisiones = {};
                        let mapAprobaciones = {};
                        let mapTextosInconsitenciaRevision= {};

                        for(var key of Object.keys(this.respuestasRegistradas)){
                            // console.log(key)
                            /* var element = {
                                 [this.respuestasRegistradas[key].respuestasId] : this.respuestasRegistradas[key].respuesta
                             }*/
                            

                            //!Agregar al array de medios habilitados si en alguna pregunta existe una inconistencia para habilitar
                            

                             //console.log(element);
                             //map[key] = { [this.respuestasRegistradas[key].respuestasId]: this.respuestasRegistradas[key].respuesta}
                             let keyName = this.respuestasRegistradas[key].respuestasId;
                             map[keyName] = this.respuestasRegistradas[key].tipoDatoId===6 || this.respuestasRegistradas[key].tipoDatoId===7 
                                ? parseInt(this.respuestasRegistradas[key].respuesta) 
                                : this.respuestasRegistradas[key].respuesta;


                            //!Asignar los estados de revision a las respuestas boleta
                            mapRevisiones[keyName] = this.respuestasRegistradas[key].estadoRevision;

                            //!Asignar los estados de aprobacion a las respuestas boleta
                            mapAprobaciones[keyName] = this.respuestasRegistradas[key].estadoAprobacion;


                            //!Asignar los textos de inconsistencia a las respuestas 
                            mapTextosInconsitenciaRevision[keyName] = this.respuestasRegistradas[key].textoInconsistencia;




                            //Asignar el disabled o enabled (disponible solo si) para los si/no de sus respuestas dependientes. y si el estado de la boleta es 2 (habilitada para informadores)
                           // console.log(this.respuestasRegistradas[key].respuestasId)
                            if(this.estadoBoletaId == 3){
                               
                                if(this.respuestasRegistradas[key].tipoDatoId===6){
                                    //console.log(this.respuestasRegistradas[key])
                                    let valorComparar = parseInt(this.respuestasRegistradas[key].respuesta);
                                    //console.log(`${this.respuestasRegistradas[key].respuestasId} -- ${valorComparar} este `)
                                    this.getDisabledEnabled(this.respuestasRegistradas[key].respuestasId, valorComparar);
                                }
                            }

                            //!Asignar disabled = true a todas las respuestas si el estado de la boleta es 5 (Segunda Habilitación para informadores) 
                            if(this.estadoBoletaId == 5){

                                this.disabled[this.respuestasRegistradas[key].respuestasId]=true;

                            }


                           //  this.respuestasPregunta.push({[this.respuestasRegistradas[key].respuestasId] : this.respuestasRegistradas[key].respuesta});

                        }

                        this.respuestasPregunta = map;
                        this.estadosRevision = mapRevisiones;
                        this.estadosAprobacion = mapAprobaciones;
                        this.textosInconsistenciaRevision = mapTextosInconsitenciaRevision;

                        //console.log(map)
                    } 
                    this.tableLoading =false;
                //console.log(this.etnias)
                })
                .catch(()=> {
                    this.tableLoading = false;
                    //console.log(err)
                });
    },


    //!Obtner los medios de verificacion registrados para la boleta (muni periodo)
    async obtenerMediosAsignados(){

        this.mediosLoading=true;
         await this.$store
                .dispatch(OBTENER_MEDIOS_VERIFICACION_PREGUNTA_MUNI, this.boletaMunicipalidadId)
                .then(res => {
                    if(res.status===200){
                        this.mediosAsignados=res.data;

                        let map = {};
                        for(var key of Object.keys(this.mediosAsignados)){
                            /* var element = {
                                 [this.respuestasRegistradas[key].respuestasId] : this.respuestasRegistradas[key].respuesta
                             }*/
                            

                             //console.log(element);
                             //map[key] = { [this.respuestasRegistradas[key].respuestasId]: this.respuestasRegistradas[key].respuesta}
                             let keyName = this.mediosAsignados[key].mediosVerificacionPreguntaId;
                             map[keyName] = this.mediosAsignados[key].path;

                           //  this.respuestasPregunta.push({[this.respuestasRegistradas[key].respuestasId] : this.respuestasRegistradas[key].respuesta});

                        }

                        this.mediosPregunta = map;


                    }
                    this.mediosLoading=false;
                })
                .catch(() => {
                    //this.tableLoading = false;
                    //console.log(err)
                    this.mediosLoading=false;
                });

    },

    //!Guardar las respuestas de las boletas
     async guardarRespuestas(){
        for (var key of Object.keys(this.respuestasPregunta)) {
            //console.log(key + " -> " + this.respuestasPregunta[key])

            this.datosRespuesta.listRespuestasMuni.push({respuestasId: parseInt(key), respuesta: this.respuestasPregunta[key].toString()});
        }
        //console.log(this.datosRespuesta);
        
         this.btnRegistroLoading=true;
         this.dialogLoaderVisible=true;
         this.dialogLoaderText='Guardando infomración...';

         this.datosRespuesta.boletaMunicipalidadId = this.boletaMunicipalidadId;
         await this.$store
            .dispatch(REGISTRAR_RESPUESTAS_MUNI, this.datosRespuesta)
            .then(res => {
                //console.log(res)
                if(res.status===200){
                    this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                    
                } else {
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                }
                this.btnRegistroLoading=false;
                this.dialogLoaderVisible=false;
                this.datosRespuesta.listRespuestasMuni=[];
            })
            .catch(error => {
                //console.log(error)
                this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                this.btnRegistroLoading=false;
                this.dialogLoaderVisible=false;
                this.datosRespuesta.listRespuestasMuni=[];
            });

        


       /* this.rolesSeleccionados.forEach(element => {
               
                this.datosUsuario.roles.push({idRol: element.id});
            });**/
      },

    //!Registrar el medio de verificación
    guardarMedio(medioVerificacionPreguntaId){

        this.dialogLoaderVisible=true;
        this.dialogLoaderText='Almacenando medio de verificación...';

        this.datosMedio.boletaMunicipalidadId = this.boletaMunicipalidadId;
        this.datosMedio.mediosVerificacionPreguntaId= medioVerificacionPreguntaId;
        this.datosMedio.nombreArchivo=this.archivoMV.name;

       // console.log(this.archivoMV);
        if(this.archivoMV!= null){
            //Cargar Archivo de medio de verificacion en el server
            this.cargarMV()
            .then(() => {
            
                //?Validar que el archivo fue cargado
                if(this.archivoCargado){

                    this.dialogLoaderText='Registrando medio de verificación...';
                    this.registrarMedioVerificacion();
                    
                } else {
                    this.dialogLoaderVisible=false;
                }
            })
            .catch(() => {
                this.dialogLoaderVisible=false;
            }); 
        } else {
            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `No se ha seleccionado un archivo válido, por favor inténtalo de nuevo, si el problema persiste, ponte en contacto con un administrador del sistema`);
            this.dialogLoaderVisible=false;
        }

    },
    
    //!Cargar el archivo de medio de verificación por pregunta
    async cargarMV(){
       
       const file = this.archivoMV;

        await 
        this.$store.dispatch(CARGAR_ARCHIVO, {file:file, path: '\\documentos\\municipalidades\\boletas\\mediosverificacion\\'})
        .then(res => {
            //console.log(res)
            if(res.status===200){
                this.archivoCargado = true;
                this.datosMedio.path = res.pathArchivo;
                return true;
            }
            else {
                this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                this.archivoCargado = false;
                return false;
            }
        })
        .catch(() => {
            //console.log(error)
            return false;
            
        });
    },

    //!Registrar el path del medio en la dashboard
    async registrarMedioVerificacion(){
        //console.log(this.datosMedio);
       
       await 
        this.$store.dispatch(REGISTRAR_MEDIO_VERIFICACION_PREGUNTA_MUNI, this.datosMedio)
        .then(res => {
            //console.log(res)
            if(res.status===200){
                this.dialogLoaderVisible=false;
                this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                this.resetMvFile();
                this.obtenerMediosAsignados();
            } else{
                let msg = `Ha ocurrido un error durante el proceso de registro, por favor, ponte en contacto con un administrador del sistema`;
                if(res.message)
                    msg= res.message;

                this.$refs.snackalert.SnackbarShow('success', 'Mensaje', msg);
            }

            this.dialogLoaderVisible=false;
        })
        .catch(() => {
            //console.log(error)
            return false;
            
        });

        
    },


    //!Realizar el reset del control del archivo de medioVerificacionId
    resetMvFile(){
        //document.querySelector('#'+controlId).value = null; 
        //console.log(this.datosMedio.mediosVerificacionPreguntaId)
        this.archivoValido=[];   
        this.archivosMV=[];
        this.archivoMV=[];
        this.$refs[`mvFile${this.datosMedio.mediosVerificacionPreguntaId}`][0].reset();
        this.datosMedio={
                path:null,
                mediosVerificacionPreguntaId: 0,
                boletaMunicipalidadId: this.boletaMunicipalidadId,
                nombreArchivo: null,
                estadosId: 1,
        };

        
        //this.$refs[controlId].value=null;
        
        //this.archivosMV=null;
        //this.archivoMV=[];
        
    },


    //!Validar el archivo que se carga para cada medio de verificación
    onFileChange(e, medioVerificacionId, controlId){
        //console.log(e);
        //console.log(medioVerificacionId)
       // console.log("aqui")
        if(e){
            //!?Validar que el tipo de archivo sea pdf
            if (e.type != "application/pdf" && e.type != "image/jpeg" ){
                // Api call
                this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `El archivo que desea ingresar no es válido.`);
                //console.log("no es un pdf..")
                //this.$refs.file.reset();
                //this.$refs.mvFile.reset();
                //document.querySelector('#'+controlId).value = null;
                
                //this.$refs[controlId][0].reset();
                //this.$refs[controlId].value=null;
                this.archivosMV[medioVerificacionId]=null;
                this.archivosMV=[];
                this.archivoMV=[];
                this.archivoValido[medioVerificacionId]=false;
                
                this.$refs[controlId][0].reset();
                return false;
            }
            //?Validar que el tamaó del archivo no exceda los 5Mb
            else if ((e.size/1024/1024) > 25){
                this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `El tamaño del archivo excede el límite permitido (25Mb)`);
                // this.$refs.file.reset();
                //this.$refs.mvFile.reset();
               // document.querySelector('#'+controlId).value = null;
                //this.$refs.mvFile.value=null;
                
                this.archivosMV[medioVerificacionId]=null;
                this.archivosMV=[];
                this.archivoMV=[];
                this.archivoValido[medioVerificacionId]=false;
                
                this.$refs[controlId][0].reset();
                //this.$refs[controlId].value=null;

                return false;
            } else {
                this.archivoValido[medioVerificacionId] = true;
                this.archivoMV = e;
               // console.log(this.archivoMV)
            }
            
        } else {
             this.archivoValido=[];
        }
    },

    //!Descargar el archivo de medio de verificación
    descargarArchivo(path){
       // console.log(path)
        window.open(path, "_blank");
    },



    //!Realizar la sumatoria de los campos
    sumarNumero(preguntaId){
      //  console.log(preguntaId)
         //console.log(this.respuestasPregunta)

        let totalSuma=0;
        Object.keys(this.respuestasPregunta).forEach(key => {
                    
            let valorR = this.respuestasPregunta[key];
            this.preguntas.forEach(function(pregunta){
                
                pregunta.listaRespuestas.forEach(function(respuesta){
                    if(pregunta.preguntaId===preguntaId){
                        //console.log(respuesta.idRespuesta + ' '+ key)
                        if(respuesta.idRespuesta==key){
                            //?Validar que los tipos de dato sean: Numero(1), SI/NO(6) y que estén marcados como elementos de una sumatoria(1)
                            if((respuesta.tipoDatoId===1 || respuesta.tipoDatoId===6) && respuesta.elementoSumatoria===1){
                                

                                //?Validar que el tipo de dato sea SI/NO, para definir el valor de 0 ya que NO está definido como 2
                                if(respuesta.tipoDatoId===6 && Number(valorR)===2)
                                    valorR = 0;

                                totalSuma = Number(totalSuma) + Number(valorR) ;
                                
                            }
                        }   

                    } 
                });

                //!Recorrer las supreguntas de pregunta
                pregunta.subPreguntaN1.forEach(function(preguntaN1){
                    
                    //!Recorrer las respuestas de la subpregunta
                    preguntaN1.listaRespuestas.forEach(function(respuestaN1){
                       // console.log(preguntaId + " " + preguntaN1.preguntaId)
                        if(preguntaN1.preguntaId===preguntaId){
                            
                            if(respuestaN1.idRespuesta==key){
                                //console.log(respuestaN1.idRespuesta + ' '+ key)
                                //?Validar que los tipos de dato sean: Numero(1), SI/NO(6) y que estén marcados como elementos de una sumatoria(1)
                                if((respuestaN1.tipoDatoId===1 || respuestaN1.tipoDatoId===6) && respuestaN1.elementoSumatoria===1){
                                    

                                    //?Validar que el tipo de dato sea SI/NO, para definir el valor de 0 ya que NO está definido como 2
                                    if(respuestaN1.tipoDatoId===6 && Number(valorR)===2)
                                        valorR = 0;

                                    totalSuma = Number(totalSuma) + Number(valorR) ;
                                    //console.log(valorR)
                                    
                                }
                            }   

                        } 
                    });

                })

                
            
            
            });                    
        })

        //console.log(totalSuma)

        

        //!Buscar la respuesta que tiene el tipo de dato sumatoria (3) y asignarle el total
        this.preguntas.forEach((pregunta) => {
                
            pregunta.listaRespuestas.forEach((respuesta) => {
                if(pregunta.preguntaId===preguntaId){
                    //console.log(respuesta.idRespuesta + ' '+ key)
                    
                    if(respuesta.tipoDatoId===3){
                        //console.log(this.respuestasPregunta[4])
                        //console.log(totalSuma)
                        this.respuestasPregunta[respuesta.idRespuesta]=totalSuma.toString();
                        //console.log(this.respuestasPregunta[respuesta.idRespuesta])
                       // console.log("pregunta")
                    }
                

                } 
            });


            //!Nivel 1 de preguntas (Subpreguntas)
            pregunta.subPreguntaN1.forEach((preguntaN1) => {

                    preguntaN1.listaRespuestas.forEach((respuestaN1) => {

                        if(preguntaN1.preguntaId===preguntaId){
                            //console.log(respuesta.idRespuesta + ' '+ key)
                            
                            if(respuestaN1.tipoDatoId===3){
                                //console.log(this.respuestasPregunta[4])
                                //console.log(totalSuma)
                                this.respuestasPregunta[respuestaN1.idRespuesta]=totalSuma.toString();
                                //console.log("subpregunta")
                                //console.log(this.respuestasPregunta[respuestaN1.idRespuesta])
                                //console.log(this.respuestasPregunta[respuesta.idRespuesta])
                            }
                        

                        } 

                    });

            });


        
        
        });
        
    },
     assign(obj, keyPath, value) {
        let lastKeyIndex = keyPath.length-1;
        for (var i = 0; i < lastKeyIndex; ++ i) {
            let key = keyPath[i];
            if (!(key in obj)){
            obj[key] = {}
            }
            obj = obj[key];
        }
        obj[keyPath[lastKeyIndex]] = value;
        },
        

        //!Buscar las respuestas que deben de deshabilitarse
        getDisabledEnabled(respuestaRefId, valorActual){
          // console.log(`${respuestaRefId} ${valorActual}`)
           // ASIGNAR SI ESTA DESHABILITADO O NO
            this.preguntas.forEach(element => {
                
                element.listaRespuestas.forEach(respuestas1 => {
                
                    
                    for(var key of Object.keys(respuestas1.listaValidaciones)){
                        //let tempElement = {};
                        //console.log(respuestas1.listaValidaciones)
                        //this.asignarValidacionesRespuesta(respuestas1, key );
                        if(respuestas1.listaValidaciones[key].respuestasIdValorSeleccionado == respuestaRefId){
                             //console.log(respuestas1.listaValidaciones[key].respuestasId)
                            //console.log(valorActual)
                            //!Definir true o false para disabled en funcion del valor actual del elemento
                            //console.log(valorActual);
                            if(valorActual===0 || valorActual===2){
                                this.disabled[respuestas1.listaValidaciones[key].respuestasId]=true;

                                //Borrar el contenido de la respuesta al deshabilitarla 
                                this.respuestasPregunta[respuestas1.idRespuesta] = '';
                                //Eliminar por completo el key que contiene la respuesta
                                delete this.respuestasPregunta[respuestas1.idRespuesta];
                               // console.log(element)

                                //!Realizar la actualizacion de la sumatoria si el tipo de dato es 1 (numero)
                                if(respuestas1.tipoDatoId===1){
                                    this.sumarNumero(element.preguntaId)
                                }
                                //sumarNumero(pregunta.preguntaId)

                            } else if(valorActual===1){
                                //console.log(`${respuestaRefId} ${valorActual}`)
                                let idP = respuestas1.listaValidaciones[key].respuestasId;
                                this.estadoBoletaId == 5 ? this.disabled[idP]= true : this.disabled[idP]=false;
                                //console.log(this.disabled[idP]);


                            } else if(Number.isNaN(valorActual)){
                                let idP = respuestas1.listaValidaciones[key].respuestasId;
                                //Si el estado de boleta es 5 deshabilitar todo
                                this.disabled[idP]=true;
                               // console.log(valorActual);
                            }
                            else {
                                let idP = respuestas1.listaValidaciones[key].respuestasId;
                                //Si el estado de boleta es 5 deshabilitar todo
                                this.disabled[idP]=true;
                               // console.log(valorActual);
                            }
                            
                        }

                    }

    
                    // this.respuestasPregunta[`${respuestas1.idRespuesta}`] = tempValidaciones1;
                        //console.log(this.reglasPregunta);
                });

                //Subpreguntas Nivel 1
                element.subPreguntaN1.forEach(preguntas2 => {
                    //console.log(preguntas2)

                    preguntas2.listaRespuestas.forEach(respuestas2 => {

                        

                        for(var key of Object.keys(respuestas2.listaValidaciones)){
                            
                            if(respuestas2.listaValidaciones[key].respuestasIdValorSeleccionado == respuestaRefId){
                               
                               // console.log(valorActual)
                                //!Definir true o false para disabled en funcion del valor actual del elemento
                                if(valorActual===0 || valorActual===2){

                                    this.disabled[respuestas2.listaValidaciones[key].respuestasId]=true;

                                   // console.log(respuestas2)

                                    //Borrar el contenido de la respuesta al deshabilitarla 
                                    this.respuestasPregunta[respuestas2.idRespuesta] = '';

                                    //Eliminar por completo el key que contiene la respuesta
                                    delete this.respuestasPregunta[respuestas2.idRespuesta];

                                    // console.log(preguntas2)
                                    //!Realizar la actualizacion de la sumatoria si el tipo de dato es 1 (numero)
                                    if(respuestas2.tipoDatoId===1){
                                        this.sumarNumero(preguntas2.preguntaId)
                                    }

                                    

                                } else if(valorActual===1){
                                    let idP = respuestas2.listaValidaciones[key].respuestasId;
                                    this.estadoBoletaId == 5 ? this.disabled[idP]=true : this.disabled[idP]=false;
                                   // console.log(respuestas2.listaValidaciones[key].respuestasId)
                                    //console.log(valorActual)
                                    //console.log(this.disabled[respuestas2.listaValidaciones[key].respuestasId])
                                } else if(Number.isNaN(valorActual)){
                                    let idP = respuestas2.listaValidaciones[key].respuestasId;
                                    this.disabled[idP]=true;
                                    //console.log(valorActual);
                                }
                                else {
                                    let idP = respuestas2.listaValidaciones[key].respuestasId;
                                    this.disabled[idP]=true;
                                    //console.log(valorActual);
                                }
                                
                            }
                        }
                    });


                });

                this.$refs.myForm.validate();
            })
    }
    
    

    },


    created(){

        this.baseIntUrl = API_BASE_URL;


        this.parameters = this.$route.params;
        this.boletaSeleccionada = parseInt(this.parameters.idBoleta);
        this.periodoSeleccionado = parseInt(this.parameters.idPeriodo);
        this.boletaMunicipalidadId=parseInt(this.parameters.boletaMuniId);

        this.obtenerDatosBoleta();

        this.obtenerMediosAsignados();
        //Definir el nombre en el breadcrumb
      
        
        this.obtenerPreguntasPorIndice().then(()=>{

            this.obtenerRespuestasMunicipalidad().then(()=>{
                this.$refs.myForm.validate();
            });
            
        });
    },
    
    mounted() {
          this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Municipalidades", route: "/dashboard" },
            { title: "Boletas" },
            { title: "Responder" }
        ]);
    },

    computed: {
      
    }


}
</script>
<style lang="scss">

    
</style>